import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/user/add/many/tenant.user.add.many.mutation.gql"
import type {
  TenantUserAddManyMutation,
  TenantUserAddManyMutationVariables,
} from "@/v2-backoffice-client/tenant/user/add/many/__types__/tenant.user.add.many.mutation"

type Options = MutationHookOptions<
  TenantUserAddManyMutation,
  TenantUserAddManyMutationVariables
>

export function useTenantUserAddManyMutation(options?: Options) {
  return useMutation<
    TenantUserAddManyMutation,
    TenantUserAddManyMutationVariables
  >(mutation, options)
}
